import Input from "components/common/Input";
import SearchIcon from "components/icons/SearchIcon";
import Button from "components/common/Button";
import Colors from "assets/Colors";

import { useTranslation } from "react-i18next";
import s from "../../../styles/TopMenu.styles";

function TopMenu({ changeSearchValue, addCategory, addSubCategory, loading }) {
  const { t } = useTranslation();
  return (
    <s.Container
      style={{
        display: "block",
      }}
    >
      <s.Title>
        {t("components.InventoryCategories.TopMenu.searchCategories")}
      </s.Title>
      <s.BottomContainer
        style={{
          marginBottom: "10px",
        }}
      >
        <Input
          disabled={loading}
          placeholder={t("components.InventoryCategories.TopMenu.search")}
          style={{
            marginBottom: "7px",
            maxWidth: "365px",
          }}
          prefix={<SearchIcon />}
          onChange={(e) => changeSearchValue(e.target.value)}
        />
        <s.BottomRightItemsContainer>
          <Button
            disabled={loading}
            type="primary"
            style={{
              background: Colors.background_secondary,
              color: Colors.text_primary,
              width: "none",
              fontWeight: "500",
              border: "solid 1px",
              height: "40px",
              marginBottom: "7px",
              textShadow: "none",
              marginRight: "13px",
            }}
            onClick={addSubCategory}
          >
            {t("components.InventoryCategories.TopMenu.addSubcategory")}
          </Button>
          <Button
            disabled={loading}
            type="primary"
            style={{
              background: Colors.primary,
              color: Colors.text_on_secondary,
              width: "none",
              fontWeight: "500",
              border: "none",
              height: "40px",
              marginBottom: "7px",
            }}
            onClick={addCategory}
          >
            {t("components.InventoryCategories.TopMenu.addCategory")}
          </Button>
        </s.BottomRightItemsContainer>
      </s.BottomContainer>
    </s.Container>
  );
}

export default TopMenu;
